import { Chip } from "@mui/material"
import { styled } from "@mui/material/styles"

const StyledChip = styled(Chip)(({ status }) => {
  let backgroundColor, color
  switch (status) {
    case "Aktiv":
      backgroundColor = "#FFB4B4"
      color = "#BD2121"
      break
    case "Avslutad":
      backgroundColor = "#BAE3C3"
      color = "#2F6C12"
      break
    case "Pågående":
      backgroundColor = "rgba(244, 152, 0, 0.2)"
      color = "#F49800"
      break
    default:
      break
  }
  return { backgroundColor, color }
})

export const VehicleAlarmChip = ({ status, label }) => {
  return <StyledChip size="small" status={status} label={label} />
}
